/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dnamw_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Small differences arise from chemical modifications, 5' phosphates or different end chemistries. The calculator uses the standard unmodified anhydrous values.`)
};

const es_dnamw_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las pequeñas diferencias surgen de modificaciones químicas, fosfatos en 5' o distintas químicas terminales. La calculadora usa los valores anhidros estándar sin modificar.`)
};

const de_dnamw_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kleine Unterschiede entstehen durch chemische Modifikationen, 5'-Phosphate oder unterschiedliche Endchemien. Der Rechner verwendet die standardmäßigen unmodifizierten wasserfreien Werte.`)
};

const nl_dnamw_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kleine verschillen ontstaan door chemische modificaties, 5'-fosfaten of andere eindchemie. De calculator gebruikt de standaard ongemodificeerde anhydrische waarden.`)
};

const fr_dnamw_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De petites différences proviennent de modifications chimiques, de phosphates en 5' ou de chimies terminales différentes. Le calculateur utilise les valeurs anhydres standards non modifiées.`)
};

const it_dnamw_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piccole differenze derivano da modifiche chimiche, fosfati 5' o diverse chimiche terminali. Il calcolatore usa i valori anidri standard non modificati.`)
};

const pt_br2_dnamw_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pequenas diferenças surgem de modificações químicas, fosfatos 5' ou diferentes químicas terminais. A calculadora usa os valores anidros padrão sem modificações.`)
};

const pt_dnamw_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pequenas diferenças surgem de modificações químicas, fosfatos em 5' ou diferentes químicas terminais. A calculadora usa os valores anidros padrão não modificados.`)
};

const ja_dnamw_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`化学修飾、5'リン酸、または異なる末端化学の違いから小さな差が生じます。この計算ツールは標準的な無修飾の無水値を使用しています。`)
};

const zh_dnamw_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`细微差异可能来自化学修饰、5' 磷酸基团或不同的末端化学方式。本计算器使用标准的未修饰无水数值。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dnamw_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dnamw_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dnamw_faq_a3", locale)
	if (locale === "en") return en_dnamw_faq_a3(inputs)
	if (locale === "es") return es_dnamw_faq_a3(inputs)
	if (locale === "de") return de_dnamw_faq_a3(inputs)
	if (locale === "nl") return nl_dnamw_faq_a3(inputs)
	if (locale === "fr") return fr_dnamw_faq_a3(inputs)
	if (locale === "it") return it_dnamw_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_dnamw_faq_a3(inputs)
	if (locale === "pt") return pt_dnamw_faq_a3(inputs)
	if (locale === "ja") return ja_dnamw_faq_a3(inputs)
	return zh_dnamw_faq_a3(inputs)
};